<template>
  <ripristinable-dialog v-model="isActive" @confirm="onConfirm" :title="$t('agricoltori.messaggi.eliminato')">

    <v-flex xs12>
      <icon-label icon="business" color="accent">{{ $t('agricoltori.label.dati_azienda') }}</icon-label>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.ragione_sociale') }}: </span>
      <b>{{ agricoltore.ragione_sociale }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.partita_iva') }}: </span>
      <b>{{ agricoltore.partita_iva || '-'}}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.cuaa') }}: </span>
      <b>{{ agricoltore.cuaa }}</b>
    </v-flex>

    <v-flex xs12 class="mt-4">
      <icon-label icon="person" color="accent">{{ $t('agricoltori.label.dati_titolare') }}</icon-label>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.nome_cognome') }}: </span>
      <b>{{ agricoltore.nome_titolare || '-' }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.sesso') }}: </span>
      <b>{{ agricoltore.sesso || '-' }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.data_nascita') }}: </span>
      <b>{{ agricoltore.data_nascita ? $d($utils.date.toJs(agricoltore.data_nascita)) : '-' }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.luogo_nascita') }}: </span>
      <b>{{ agricoltore.luogo_nascita || '-' }}</b>
    </v-flex>

    <v-flex xs12 class="mt-4">
      <icon-label icon="contacts" color="accent">{{ $t('label.contatti') }}</icon-label>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.sdi') }}: </span>
      <b>{{ agricoltore.sdi || '-' }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.pec') }}: </span>
      <b>{{ agricoltore.pec || '-' }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.email') }}: </span>
      <b>{{ agricoltore.email || '-' }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.telefono') }}: </span>
      <b>{{ $utils.formatPhone(agricoltore.telefono) }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.cellulare') }}: </span>
      <b>{{ $utils.formatPhone(agricoltore.cellulare, type='mobile') }}</b>
    </v-flex>

  </ripristinable-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import RipristinableDialog from '@/components/base/RipristinableDialog'

export default {
    name: 'AgricoltoreDeletedDialog',
    mixins: [Toggleable],
    components: { RipristinableDialog },
    data: () => ({
        agricoltore: {}
    }),
    methods: {
        show (agricoltore) {
            this.agricoltore = agricoltore
            this.isActive = true
        },
        onConfirm () {
            let vue = this
            this.$confirmDialog.show(
                this.agricoltore.id,
                this.$t('agricoltori.messaggi.conferma_ripristino'),
                function (id) {
                    this.$api.agricoltori.restore(id)
                        .then(() => {
                            vue.$snackbar.show(this.$t('agricoltori.messaggi.ripristinato'), 'success')
                            vue.$emit('success')
                            vue.isActive = false
                        }).catch(e => {
                            if (e.response.status === 304) {
                                vue.$snackbar.show(this.$t('agricoltori.errori.errore_ripristino'), 'error')
                            } else {
                                vue.$snackbar.showServerError(e)
                            }
                        })
                })
        }
    }
}
</script>
